import { StrapiResponseI } from "@/interfaces/strapi/api";
import {
  StrapiImageFormatSizeI,
  StrapiImageI,
} from "@/interfaces/strapi/image";
import { postImgUrl } from "@/helpers/post";

export const getEntityAttributesFromStrapiList = <EntityType>(
  response: StrapiResponseI<EntityType>
): EntityType[] => response.data?.map((entity) => entity.attributes) || [];

export const getStrapiImageURL = (
  image: StrapiImageI,
  formatToPick: StrapiImageFormatSizeI = "medium"
) => {
  const attributes = image?.data?.attributes;

  if (attributes) {
    return postImgUrl(
      attributes?.formats?.[formatToPick]?.url || attributes?.url
    );
  }

  return null;
};
